(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["can-whey-section-faq"] && !Shopify.designMode) return;
  try {
    
  // Vanilla JavaScript Accordion Implementation
  document.addEventListener('DOMContentLoaded', function () {
    const accordionTriggers = document.querySelectorAll('[data-slot="accordion-trigger"]');

    accordionTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();

        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        const targetId = trigger.getAttribute('aria-controls');
        const content = document.getElementById(targetId);
        const accordionItem = trigger.closest('[data-slot="accordion-item"]');
        const plusIcon = trigger.querySelector('.can-whey-plus-icon');

        if (!content || !accordionItem) return;

        if (isOpen) {
          // Close
          trigger.setAttribute('aria-expanded', 'false');
          trigger.setAttribute('data-state', 'closed');
          content.setAttribute('data-state', 'closed');
          accordionItem.setAttribute('data-state', 'closed');
          content.hidden = true;

          if (plusIcon) {
            plusIcon.style.transform = 'rotate(0deg)';
          }

          // Announce closure to screen readers
          const statusDiv = document.getElementById('faq-status');
          if (statusDiv) {
            statusDiv.textContent = 'FAQ item collapsed';
          }
        } else {
          // Open
          trigger.setAttribute('aria-expanded', 'true');
          trigger.setAttribute('data-state', 'open');
          content.setAttribute('data-state', 'open');
          accordionItem.setAttribute('data-state', 'open');
          content.hidden = false;

          if (plusIcon) {
            plusIcon.style.transform = 'rotate(45deg)';
          }

          // Announce opening to screen readers
          const statusDiv = document.getElementById('faq-status');
          if (statusDiv) {
            statusDiv.textContent = 'FAQ item expanded';
          }
        }
      });

      // Keyboard navigation
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          trigger.click();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
